module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isRender) ? _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('CamInfo', {
    attrs: {
      "campaignType": _vm.campaignType,
      "isInterPlay": _vm.isInterPlay,
      "checkDate": _vm.checkDate
    }
  }), _vm._v(" "), _c('router-view')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/interview/static/img/loading.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30dc1a64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/camMain/CampaignMain.vue
// module id = 837
// module chunks = 1